var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showUpgradeSelector || _vm.showLanguageSelector
    ? _c("div", [
        _c("div", { staticClass: "soft-language" }, [
          _vm.showUpgradeSelector
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-5 col-md-12" }, [
                  _c("div", { staticClass: "soft-language__title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.getTranslation(
                            "software-languages-vue",
                            "choose_customer_type"
                          )
                        ) +
                        "\n                    "
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover",
                            value: {
                              content: _vm.getTranslation(
                                "software-languages-vue",
                                "choose_customer_type_help"
                              ),
                              html: true,
                              placement: "bottom",
                            },
                            expression:
                              "{content: getTranslation('software-languages-vue', 'choose_customer_type_help'), html: true, placement: 'bottom'}",
                            modifiers: { hover: true },
                          },
                        ],
                        staticClass: "popover-item",
                        attrs: { href: "#", tabindex: "0" },
                      },
                      [_c("span", [_vm._v("?")])]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-7 col-sm-12" },
                  [
                    _c(
                      "select2",
                      {
                        staticClass: "form-control",
                        attrs: {
                          "data-width": "100%",
                          "data-minimum-results-for-search": "Infinity",
                          value: _vm.forceUserType,
                          name: "forceUserType",
                          "data-theme": "bootstrap4",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setForceUserType($event)
                          },
                        },
                      },
                      _vm._l(_vm.canUpgradeUserTypes, function (val, key) {
                        return _c("option", { domProps: { value: val } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.getTranslation(
                                  "user-types",
                                  "select_user_type_" + val
                                )
                              ) +
                              "\n\n                    "
                          ),
                        ])
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.showLanguageSelector
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-5 col-md-12" }, [
                  _c("div", { staticClass: "soft-language__title" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.getTranslation(
                            "software-languages-vue",
                            "software_language"
                          )
                        ) +
                        "\n                    "
                    ),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover",
                            value: {
                              content: _vm.getTranslation(
                                "software-languages-vue",
                                "software_language_help"
                              ),
                              html: true,
                              placement: "bottom",
                            },
                            expression:
                              "{content: getTranslation('software-languages-vue', 'software_language_help'), html: true, placement: 'bottom'}",
                            modifiers: { hover: true },
                          },
                        ],
                        staticClass: "popover-item",
                        attrs: { href: "#", tabindex: "0" },
                      },
                      [_c("span", [_vm._v("?")])]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-7 col-sm-12" },
                  [
                    _c(
                      "select2",
                      {
                        staticClass: "soft-language__select form-control",
                        attrs: {
                          "data-width": "100%",
                          "data-placeholder": "Select program language",
                          "data-minimum-results-for-search": "Infinity",
                          value: _vm.selectedLanguage,
                          name: "program_language_id",
                          "data-theme": "bootstrap4",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.setSoftwareLanguage($event)
                          },
                        },
                      },
                      _vm._l(_vm.sortedLanguages, function (language, code) {
                        return _c(
                          "option",
                          { domProps: { value: language[0] } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(language[1]) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }